<!-- <p>data-integrations-neuronsensors-manage works!</p> -->
@if (!selectedIntegration || !NeuronSensorConfig || !NeuronSensorSystem) {
<app-loading-template DisplayText="Please wait while we load sensor configuration" />
} @else {
<!-- Add a SideNav Dock Page -->
<app-dock-content>
    <ng-template #navbar class="alignRow">
        <h1>{{NeuronSensorSystem.name}} Sensor Configuration</h1>
        <div class="me-auto"></div>
        <button mat-raised-button (click)="back()" class="app-icon--back">
            <mat-icon />
            <span>Back</span>
        </button>
    </ng-template>

    <ng-template #content>

        <div class="neuron-sensors-configuration">

            <div class="configuration-heading">
                <!-- <p>Select the NeuronSensors you want to include in this configuration.</p> -->
                <table>
                    <tr>
                        <th>System ID:</th>
                        <td>{{ NeuronSensorConfig.system }}</td>
                        <th>Integration ID:</th>
                        <td>{{ NeuronSensorConfig.id }}</td>
                        <th>Webhook ID:</th>
                        <td>{{ selectedIntegration.WebhookUID }}</td>
                    </tr>
                    <tr>
                        <th>System Name:</th>
                        <td>{{ NeuronSensorSystem.name }}</td>
                        <th>Integration Name:</th>
                        <td>{{ NeuronSensorConfig.name }}</td>
                        <th>Webhook Description:</th>
                        <td>{{ selectedIntegration.Description }}</td>
                    </tr>
                    <tr>
                        <th>SN Configured:</th>
                        <td colspan="5">
                            @if (NeuronSensorConfig.sensors.length > 0){
                            {{NeuronSensorConfig.sensors.join(", ")}}
                            } @else {Neuron Sensors is sending data for all sensors!}
                        </td>
                    </tr>
                </table>
            </div>

            <div class="sensor-transfer-container">

                <!-- Available Sensors -->
                <div class="sensor-list-container">

                    <div class="sensor-list-heading alignRow">
                        <mat-form-field appearance="outline" class="sensor-search">
                            <input matInput type="text" placeholder="Search Sensors"
                                (input)="filterSensors($any($event.target).value, 'available')">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                        <div class="me-auto"></div>

                        <ejs-splitbutton [items]='items2' content="Select All" (click)="selectAllAvailableSensors()"
                            (select)="onSelectAvailableMenuItem($event)" />

                        <span>
                            @if(selectedAvailableSensors.length > 0){{{selectedAvailableSensors.length}}/}
                            {{ availableSensors.length }}
                        </span>
                    </div>

                    <div class="sensor-list">

                        <ejs-listview #availableSensorList id="availableSensorList"
                            [dataSource]="filteredAvailableSensors" showHeader="true"
                            headerTitle="Sensors in Neuron Sensors ({{ NeuronSensorSystem.name }})"
                            [fields]="configuredListFields" sortOrder="Ascending" [showCheckBox]="true"
                            (dragStart)="onDragStart($event)" (dragStop)="onDragStop($event)"
                            (select)="onSensorSelected($event, 'available')" [template]="sensorTemplate"
                            [groupTemplate]="groupAvailableTemplate">
                        </ejs-listview>
                    </div>

                </div>

                <!-- Transfer Controls -->
                <div class="sensor-transfer-controls">

                    @if (selectedAvailableSensors.length > 0) {

                    @if (avaliableSelectionType === 'configured') {
                    <button mat-icon-button type="button" (click)="moveSelectedToConfigured(avaliableSelectionType)"
                        matTooltip="Update selected sensor">

                        <mat-icon>refresh</mat-icon>

                    </button>
                    } @else if (avaliableSelectionType === 'avaliable') {
                    <button mat-icon-button type="button" (click)="moveSelectedToConfigured(avaliableSelectionType)"
                        matTooltip="Add selected sensor">

                        <mat-icon>chevron_right</mat-icon>

                    </button>
                    } @else if(avaliableSelectionType === 'mixed'){

                    <button mat-icon-button type="button"
                        matTooltip="Select either avaiable or configured sensors, not both">
                        <mat-icon>block</mat-icon>
                    </button>

                    }
                    }

                    @if (selectedConfiguredSensors.length > 0) {

                    @if (configuredSelectionType === 'obsolete') {

                    <button mat-icon-button type="button" (click)="deleteObsoleteSensor()"
                        matTooltip="Delete obsolete sensors">
                        <mat-icon style="color:red">delete</mat-icon>
                    </button>

                    }
                    @else if (configuredSelectionType === 'normal') {

                    <button mat-icon-button type="button" (click)="moveSelectedToAvailable()"
                        matTooltip="Remove selected sensors">
                        <mat-icon>chevron_left</mat-icon>
                    </button>

                    } @else if(configuredSelectionType === 'mixed'){

                    <button mat-icon-button type="button"
                        matTooltip="Select either obsolete or configured sensors, not both">
                        <mat-icon>block</mat-icon>
                    </button>

                    }
                    }
                </div>

                <!-- Configured Sensors -->
                <div class="sensor-list-container">

                    <div class="sensor-list-heading alignRow">
                        <mat-form-field appearance="outline" class="sensor-search">
                            <input matInput type="text" placeholder="Search Sensors"
                                (input)="filterSensors($any($event.target).value, 'configured')">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                        <div class="me-auto"></div>

                        <ejs-splitbutton [items]='items' content="Select All" (click)="selectAllConfiguredSensors()"
                            (select)="onSelectConfiguredMenuItem($event)" />

                        <span>
                            @if(selectedConfiguredSensors.length > 0){{{selectedConfiguredSensors.length}}/}
                            {{ configuredSensors.length }}
                        </span>
                    </div>

                    <div class="sensor-list">
                        <ejs-listview #configuredSensorList id="configuredSensorList"
                            [dataSource]="filteredConfiguredSensors" showHeader="true"
                            headerTitle="Configured Sensors in PrismPdM ({{selectedIntegration.Description}})" [fields]="configuredListFields"
                            sortOrder="Ascending" [showCheckBox]="true" (dragStart)="onDragStart($event)"
                            (dragStop)="onDragStop($event)" (select)="onSensorSelected($event, 'configured')"
                            [template]="sensorTemplate" [groupTemplate]="groupConfiguredTemplate">                            
                        </ejs-listview>
                    </div>

                </div>

            </div>

        </div>

    </ng-template>
</app-dock-content>
}

<ng-template #groupAvailableTemplate let-group="">
    <div class="e-list-wrapper">
        <span class="e-list-item-content flexRow">
            <span>{{group.items[0].GroupBy}}&nbsp;({{group.items.length}})</span>
            <span class="me-auto"></span>
            <button mat-button (click)="selectAvailableSensorsByGroup(group.items[0].GroupBy)">Select</button>
        </span>
    </div>
</ng-template>

<ng-template #groupConfiguredTemplate let-group="">
    <div class="e-list-wrapper">
        <span class="e-list-item-content flexRow">
            <span>{{group.items[0].GroupBy}}&nbsp;({{group.items.length}})</span>
            <span class="me-auto"></span>
            <button mat-button (click)="selectConfiguredSensorsByGroup(group.items[0].GroupBy)">Select</button>
        </span>
    </div>
</ng-template>

<ng-template #sensorTemplate let-sensor>

    <div class="sensor-list-item">

        @let src = sensor.isNeuronSensor ? sensor.img : imagePathSensors() + sensor.sensorID + '?' +sensor.Modified;
        <img class="sensor-image" [src]="src" [alt]="sensor.alias" (click)="viewImage($event,src)"
            onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'">
        
        <div class="sensor-details">

            <div class="sensor-alias">
                <span>{{ sensor.alias }}</span>
                @if (!sensor.isNeuronSensor && sensor.isObsolete) {<span class="obsolete-label">Obsolete</span>}
                @if (sensor.isNeuronSensor && sensor.isConfigured) {<span class="configured-label">Configured</span>}
            </div>

            <div class="sensor-description">{{ sensor.description }}</div>

            <div class="sensor-sn">
                <span>SN:{{ sensor.sn }}</span>
                @if (sensor.offline) {<span class="offline-label" matTooltip="No Value within last 30 mins">offline</span>}
            </div>

        </div>

    </div>

</ng-template>

@if ((updateProgress )) {
<div class="update-progress-overlay">
    <div class="update-progress-container">
        <div class="update-progress-text">
            <span>{{updateProgress.text.trim()}}&nbsp;{{updateProgress.sensor}}&nbsp;{{ updateProgress.completed
                }}&nbsp;of&nbsp;{{
                updateProgress.total }}</span>
        </div>

        <div class="update-progress-bar">
            <div class="update-progress-bar-value"
                [style.width.%]="(updateProgress.completed / updateProgress.total) * 100">
            </div>
        </div>
    </div>
</div>
}